/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EduContentBookInterface, EduContentTOCEduContentInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EduContentBookApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EduContentBooks');
  }

  find(params?): Observable<EduContentBookInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<EduContentBookInterface[]>(path, httpParams);
  }

  getData(bookId: number, fields?: string): Observable<any> {
    const path = `${bookId}/data`;
    const params = this._getHttpParams({ fields });
    return this.get<any>(path, params);
  }

  clearEduContent(bookId: number): Observable<any> {
    const path = `${bookId}/clearEduContent`;
    return this.patch<any>(path, undefined, undefined);
  }

  unlinkEduContentsRemote(bookId: number): Observable<any> {
    const path = `${bookId}/unlinkEduContents`;
    return this.patch<any>(path, undefined, undefined);
  }

  getUnlockedExercisesRemote(bookId: number): Observable<any[]> {
    const path = `${bookId}/getUnlockedExercises`;
    return this.get<EduContentTOCEduContentInterface[]>(path, undefined);
  }
}
